export class Studentregmaster {
    public StudentName: string;
    public SchoolCode: string;
    public area: string;
    public State: string;
    public City: string;
    public SchoolArea: string;
    public SchoolAddress: string;
    public SchoolMobileNo:string;
    public SchoolMailID:string;
    public StateID:number;
    public CityID:number;
    public SchoolID:number;

}